import React from "react";
import { Button } from "../../components/ui";

// "In demand" is withdrawn with the demand hook: it filtered on
// /api/core-list/insights data, which 500s in production, so it always matched
// nothing. Re-add `{ key: "in-demand", label: "In demand" }` when that endpoint
// is fixed; see the note in CoreListTemplate.
export const FILTERS = [
  { key: "all", label: "All" },
  // "At target" first among the conditions: it is the one that costs money to
  // miss — a dealer's price only stays on the table for so long.
  { key: "at-target", label: "At target" },
  { key: "out-of-stock", label: "Out of stock" },
];

/**
 * CoreListFilterPills — "All / In demand / Out of stock" segmented row.
 * Renamed from "Need restock" per spec; "In consignment" dropped entirely.
 *
 * @param {"all"|"at-target"|"in-demand"|"out-of-stock"} value
 * @param {(next: string) => void} onChange
 * @param {{all:number,"at-target":number,"in-demand":number,"out-of-stock":number}} [counts]
 */
const CoreListFilterPills = ({ value, onChange, counts = {} }) => (
  <div
    className="core-list-pills core-list-pills--filters"
    role="group"
    aria-label="Filter core list"
  >
    {FILTERS.map((f) => (
      <Button
        key={f.key}
        type="button"
        variant="tab"
        size="md"
        active={value === f.key}
        aria-pressed={value === f.key}
        onClick={() => onChange(f.key)}
      >
        {f.label}
        {counts[f.key] != null ? ` ${counts[f.key]}` : ""}
      </Button>
    ))}
  </div>
);

export default CoreListFilterPills;
